import { render, staticRenderFns } from "./loading-base.vue?vue&type=template&id=f03ea860&"
import script from "./loading-base.vue?vue&type=script&lang=ts&"
export * from "./loading-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports